"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.graph = void 0;
const tslib_1 = require("tslib");
require("@progress/kendo-ui");
require("babel-polyfill");
require("jquery-ui-bundle");
require("jquery-ui-bundle/jquery-ui.css");
require("jquery-address");
require("../../../TdWebtoolkitControls/controls/CategoryChooser/CategoryChooser");
require("../../../TdWebtoolkitControls/controls/Graph/Graph");
const SelectionContext_1 = require("../../../TdWebtoolkitControls/controls/Menu/SelectionContext");
require("../../../TdWebtoolkitControls/controls/Preview/Preview");
const Utilities_1 = require("../../../TdWebtoolkitControls/javascript/Utilities");
require("../../javascript/controls/Favorites/Favorites");
const Favorites_1 = require("../../javascript/controls/Favorites/Favorites");
const $ = require("jquery");
const m = require("../SynView");
let r_css = require("./graph.tmpl.less");
let r_addRemoveDialog = require("../../../TdWebtoolkitControls/controls/AddRemoveDialog/AddRemoveDialog");
class GraphFavorite_V1 {
    constructor(layoutType, showIcons, showDetails, multiLineTitle, parentDepth, childDepth, allowedCategories, allowedRelIds) {
        this.layoutType = layoutType;
        this.showIcons = showIcons;
        this.showDetails = showDetails;
        this.multiLineTitle = multiLineTitle;
        this.parentDepth = parentDepth;
        this.childDepth = childDepth;
        this.allowedCategories = allowedCategories;
        this.allowedRelIds = allowedRelIds;
    }
}
class graph extends m.SynView {
    constructor() {
        super();
    }
    getParametersFromUrl() {
        super.getParametersFromUrl();
        let id = $.address.parameter("id");
        if (typeof id !== "undefined")
            this.m_id = decodeURIComponent(id);
        else
            this.m_id = undefined;
        let preset = $.address.parameter("preset");
        if (typeof preset !== "undefined")
            this.m_preset = decodeURIComponent(preset);
        else
            this.m_preset = undefined;
    }
    getSelectionContext() {
        if (!this.m_$graphContainer.data("synGraph"))
            return super.getSelectionContext();
        const selectedId = this.m_$graphContainer.synGraph("getSelectedId");
        return {
            parentControl: false,
            normalParentContext: {
                parentRelId: SelectionContext_1.SpecialRelIds.Undefined
            },
            parentControlParentContext: {
                parentRelId: SelectionContext_1.SpecialRelIds.Undefined
            },
            selectedIds: selectedId ? [selectedId] : []
        };
    }
    init(viewName, viewIndex, viewHtml) {
        super.init(viewName, viewIndex, viewHtml);
        this.icon = "fa-arrows-alt";
    }
    activate() {
        super.activate();
        if (this.m_$graphContainer && this.m_$graphContainer.data("synGraph")) {
            let id = $.address.parameter("id");
            if (typeof id === "undefined")
                id = undefined;
            else {
                this.m_$graphContainer.synGraph("clearGraph");
                id = decodeURIComponent(id);
            }
            this.m_$graphContainer.synGraph("navigateTo", id, true);
        }
    }
    deactivate() {
        Utilities_1.synUtil.Notifications.remove(this.m_notificationGUID);
        this.m_notificationGUID = undefined;
        super.deactivate();
    }
    renderContents() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let that = this;
            that.m_$preview = that.m_$container.find("div.preview");
            that.m_$preview.synPreview({});
            yield that.initGraphControlAsync();
            yield that.initOptionsPaneAsync();
            yield that.setInitialOptionsAsync();
            that.wireEvents();
            this.m_$graphContainer.synGraph("navigateTo", that.m_id || undefined);
        });
    }
    resizeControls() {
        if (this.m_$graphContainer) {
            this.m_$graphContainer
                .outerHeight(this.m_$graphContainer.parent().innerHeight())
                .synGraph("resize");
        }
        this.resizeOptions();
    }
    forceRefresh(modifications) { }
    redrawGraph(refetch) {
        this.m_$graphContainer.synGraph("redrawGraph", refetch);
    }
    initGraphControlAsync() {
        let that = this;
        return new Promise((resolve, reject) => {
            that.m_$graphContainer = that.m_$container.find(".graphContainer");
            that.m_$graphContainer
                .off("initSuccess").on("initSuccess", resolve)
                .synGraph();
        });
    }
    resizeOptions() {
        kendo.resize($("#configPane").find(".levelSlider"), false);
    }
    wireEvents() {
        this.wireFavoriteEvents();
        this.wireRelationChooserEvents();
        this.wireGraphControlEvents();
        this.wireCategoryChooserEvents();
        this.wireLayoutDropDownEvents();
        this.wireCheckBoxEvents();
        this.wireSliderEvents();
        this.wireExternalChangeEvent();
    }
    getDataForNewFavorites() {
        let options = this.m_$graphContainer.synGraph("getOptions");
        return new Favorites_1.FavoriteData(1, new GraphFavorite_V1(options.layoutType, options.showIcons, options.showDetails, options.multiLineTitle, options.parentDepth, options.childDepth, options.allowedCategories, options.allowedRelIds));
    }
    initOptionsExpander() {
        let that = this;
        that.m_$optionsExpander = $("#configPane").find("a.optionsExpander");
        that.m_$optionsExpander
            .on("click", function () {
            $(this).toggleClass("closed");
            if (that.m_$optionsDetails.toggle().is(":visible"))
                that.resizeOptions();
        });
    }
    initPrintButton() {
        let that = this;
        that.m_$printButton = $("#configPane").find(".printButton");
        if (!kendo.support.mobileOS) {
            that.m_$printButton
                .show()
                .append(kendo.htmlEncode(Utilities_1.synUtil.Strings.getValue("graph.print")))
                .on("click", () => {
                that.m_$graphContainer.synGraph("print");
            });
        }
    }
    initLayoutDropDown() {
        let that = this;
        that.m_$layoutDropDown = $("#configPane").find(".layoutDropDown");
        let layouts = that.m_$graphContainer.synGraph("getAvailableLayouts");
        layouts.sort((a, b) => a.name.localeCompare(b.name));
        that.m_$layoutDropDown.kendoDropDownList({
            dataTextField: "name",
            dataValueField: "id",
            dataSource: layouts
        });
    }
    initSliders() {
        let that = this;
        that.m_$parentLevelSlider = $("#configPane").find(".parentLevelsSlider");
        that.m_$childLevelSlider = $("#configPane").find(".childLevelsSlider");
        that.m_$parentLevelSlider.add(that.m_$childLevelSlider).kendoSlider({
            increaseButtonTitle: "Right",
            decreaseButtonTitle: "Left",
            value: 0,
            min: 0,
            max: 5,
            smallStep: 1,
            largeStep: 1,
            tooltip: { enabled: false }
        });
    }
    initCategoryChooserAsync() {
        let that = this;
        return new Promise((resolve, reject) => {
            that.m_$allButton = $("#configPane").find(".catBtn.catAll");
            that.m_$noneButton = $("#configPane").find(".catBtn.catNone");
            that.m_$categoryChooser = $("#configPane").find(".categories");
            that.m_$categoryChooser
                .on("initSuccess", function () { resolve(); })
                .synCategoryChooser({
                useCategoryGroups: false,
                multiSelect: true,
                includeAbstractCategories: false,
                ignoreCreateRight: true,
                showIcons: true
            });
        });
    }
    initOptionsPaneAsync() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let that = this;
            that.m_$optionsDetails = $("#configPane").find("div.optionDetails");
            that.m_$relationChooser = $("#configPane").find(".relations");
            that.m_$showLabelsCheckBox = $("#graphShowlabelsCheckbox");
            that.m_$showIconsCheckBox = $("#graphShowIconsCheckbox");
            that.m_$multiLineTitlesCheckBox = $("#graphMultilineTitlesCheckbox");
            that.initTexts();
            that.initOptionsExpander();
            that.initPrintButton();
            that.initLayoutDropDown();
            that.initSliders();
            yield that.initCategoryChooserAsync();
            yield that.initFavoritesAsync(that.m_preset);
        });
    }
    initTexts() {
        let $cfgPane = $("#configPane");
        $cfgPane.find("a.optionsExpander").text(Utilities_1.synUtil.Strings.getValue("graph.options"));
        $cfgPane.find(".layoutHeader").text(Utilities_1.synUtil.Strings.getValue("graph.layout"));
        $cfgPane.find(".parentDepthHeader").text(Utilities_1.synUtil.Strings.getValue("graph.parentdepth"));
        $cfgPane.find(".childDepthHeader").text(Utilities_1.synUtil.Strings.getValue("graph.childdepth"));
        $cfgPane.find(".categoriesHeader").text(Utilities_1.synUtil.Strings.getValue("graph.categories"));
        $cfgPane.find(".relationsHeader").text(Utilities_1.synUtil.Strings.getValue("graph.relations"));
        $cfgPane.find(".chooseRelationsLink").text(Utilities_1.synUtil.Strings.getValue("graph.chooserelations"));
        $cfgPane.find(".showPropertiesLabel").text(Utilities_1.synUtil.Strings.getValue("graph.showproperties"));
        $cfgPane.find(".showIconsLabel").text(Utilities_1.synUtil.Strings.getValue("graph.showicons"));
        $cfgPane.find(".multiLineTitlesLabel").text(Utilities_1.synUtil.Strings.getValue("graph.multilinetitles"));
    }
    setInitialOptionsAsync() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let that = this;
            if (that.m_preset) {
                let evtPromise = new Promise((resolve, reject) => {
                    that.m_$favorites
                        .one("favoriteSelected", function (evt, id, data, isDefaultFavorite) {
                        that.applyFavorite(id, data.data, true, isDefaultFavorite);
                        resolve();
                    })
                        .synFavorites("selectFavorite", that.m_preset);
                });
                yield evtPromise;
            }
            else {
                if (that.m_$favorites.synFavorites("trySelectDefaultFavorite"))
                    yield this.setFavoriteOptionsAsync();
                else {
                    let options = that.m_$graphContainer.synGraph("getOptions");
                    that.m_$categoryChooser.synCategoryChooser("selectAllCategories");
                    that.m_$childLevelSlider.data("kendoSlider").value(options.childDepth);
                    that.m_$parentLevelSlider.data("kendoSlider").value(options.parentDepth);
                    that.m_$layoutDropDown.data("kendoDropDownList").value(options.layoutType.toString());
                    that.m_$multiLineTitlesCheckBox.prop("checked", options.multiLineTitle);
                    that.m_$showIconsCheckBox.prop("checked", options.showIcons);
                    that.m_$showLabelsCheckBox.prop("checked", options.showDetails);
                }
            }
        });
    }
    setFavoriteOptionsAsync() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let that = this;
            let favId = that.m_$favorites.synFavorites("getSelectedFavoriteId");
            if (favId) {
                let favData = yield that.m_$favorites.synFavorites("getSelectedFavoriteAsync");
                let graphData = favData.data;
                that.applyFavorite(favId, graphData, false, false);
                return false;
            }
            return true;
        });
    }
    setLayout(layoutType, redraw) {
        if (layoutType != undefined) {
            const ddl = this.m_$layoutDropDown.data("kendoDropDownList");
            ddl.value(layoutType.toString());
            this.setGraphOptions({ layoutType }, false);
            if (layoutType === 1 /* TdOrganigramm */) {
                this.setParentDepth(1, redraw);
                this.setChildDepth(1, redraw);
            }
            this.enableParentSlider(layoutType !== 1 /* TdOrganigramm */);
            this.enableChildSlider(layoutType !== 1 /* TdOrganigramm */);
        }
    }
    setParentDepth(depth, redraw) {
        if (depth != undefined && !this.m_$parentLevelSlider.closest(".k-widget").hasClass("k-state-disabled")) {
            this.m_$parentLevelSlider.data("kendoSlider").value(depth);
            this.setGraphOptions({ parentDepth: depth }, redraw);
        }
    }
    setChildDepth(depth, redraw) {
        if (depth != undefined && !this.m_$childLevelSlider.closest(".k-widget").hasClass("k-state-disabled")) {
            this.m_$childLevelSlider.data("kendoSlider").value(depth);
            this.setGraphOptions({ childDepth: depth }, redraw);
        }
    }
    setShowLabels(showLabels, redraw) {
        if (showLabels != undefined) {
            this.m_$showLabelsCheckBox.prop("checked", showLabels);
            this.setGraphOptions({ showDetails: showLabels }, redraw);
        }
    }
    setShowIcons(showIcons, redraw) {
        if (showIcons != undefined) {
            this.m_$showIconsCheckBox.prop("checked", showIcons);
            this.setGraphOptions({ showIcons }, redraw);
        }
    }
    setMultiLineTitles(multiLineTitles, redraw) {
        if (multiLineTitles != undefined) {
            this.m_$multiLineTitlesCheckBox.prop("checked", multiLineTitles);
            this.setGraphOptions({ multiLineTitle: multiLineTitles }, redraw);
        }
    }
    setAllowedCategories(allowedCategories, redraw) {
        if (!allowedCategories || !allowedCategories.length)
            this.m_$categoryChooser.synCategoryChooser("selectAllCategories");
        else
            this.m_$categoryChooser.synCategoryChooser("setSelectedCategories", allowedCategories.map(c => parseInt(c, 10)));
        this.setGraphOptions({ allowedCategories }, redraw);
    }
    setGraphOptions(graphOptions, redraw) {
        this.m_$graphContainer.synGraph("setOptions", graphOptions, !redraw);
    }
    enableParentSlider(enable) {
        this.m_$parentLevelSlider.data("kendoSlider").enable(enable);
    }
    enableChildSlider(enable) {
        this.m_$childLevelSlider.data("kendoSlider").enable(enable);
    }
    applyFavorite(id, favoriteData, updateUrlParameters, isDefaultFavorite) {
        if (updateUrlParameters)
            $.address.parameter("preset", (isDefaultFavorite ? "" : id), false);
        this.setShowIcons(favoriteData.showIcons, false);
        this.setShowLabels(favoriteData.showDetails, false);
        this.setMultiLineTitles(favoriteData.multiLineTitle, false);
        this.setLayout(favoriteData.layoutType, false);
        this.setParentDepth(favoriteData.parentDepth, false);
        this.setChildDepth(favoriteData.childDepth, false);
        this.setAllowedCategories(favoriteData.allowedCategories, false);
        this.setGraphOptions({ allowedRelIds: favoriteData.allowedRelIds }, false);
    }
    wireFavoriteEvents() {
        let that = this;
        that.m_$favorites
            .off("favoriteSelected").on("favoriteSelected", function (evt, id, data, isDefaultFavorite) {
            let graphData = data.data;
            that.applyFavorite(id, graphData, true, isDefaultFavorite);
            that.redrawGraph(true);
        })
            .off("newFavoriteRequested").on("newFavoriteRequested", function (evt, data) {
            data.favorite = that.getDataForNewFavorites();
        });
    }
    wireRelationChooserEvents() {
        let that = this;
        const noRelIds = ["NONE"];
        that.m_$relationChooser.on("click", function () {
            let options = that.m_$graphContainer.synGraph("getOptions");
            let allowedRelations = options.allowedRelIds;
            let allRelIds;
            let dlg = new r_addRemoveDialog.AddRemoveDialog({
                windowTitle: Utilities_1.synUtil.Strings.getValue("graph.chooserelations"),
                itemTemplate: "<div>#:name#</div>",
                getAllItems: (cb) => {
                    Utilities_1.synUtil.getAJAXData({
                        url: Utilities_1.synUtil.getWSUrl("GraphGetRelations"),
                        done(relations) {
                            allRelIds = $.map(relations, rel => rel.id.toString());
                            cb(relations);
                        }
                    });
                },
                getActiveItemIds: (cb) => {
                    if (!allowedRelations || !allowedRelations.length)
                        cb(allRelIds);
                    else if (allowedRelations.length === 1 && allowedRelations[0] === "NONE")
                        cb(noRelIds);
                    else
                        cb(allowedRelations);
                },
                itemToId: (item) => item.id.toString(),
                compare: (a, b) => {
                    return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1;
                },
                dialogResult: (cancel, activeIds, inactiveIds) => {
                    if (!cancel) {
                        let rels;
                        if (inactiveIds.length) {
                            if (activeIds.length)
                                rels = activeIds;
                            else
                                rels = noRelIds;
                        }
                        else
                            rels = [];
                        that.setGraphOptions({ allowedRelIds: rels }, true);
                        that.m_$favorites.synFavorites("updateFavorite", that.getDataForNewFavorites());
                    }
                }
            });
            dlg.show();
        });
    }
    wireGraphControlEvents() {
        let that = this;
        that.m_$graphContainer
            .off("nodeDoubleClicked").on("nodeDoubleClicked", function (event, id) {
            that.m_id = id;
            $.address.parameter("id", id, false);
            that.m_$graphContainer.synGraph("navigateTo", id, true);
        })
            .off("graphNodeSelected").on("graphNodeSelected", (_evt, id) => {
            that.updateSelectionContext();
            that.m_$preview.synPreview("setInstanceAsync", id);
        })
            .off("fetchGraphBegin").on("fetchGraphBegin", function () {
            Utilities_1.synUtil.Notifications.remove(that.m_notificationGUID);
            that.m_notificationGUID = Utilities_1.synUtil.Notifications.waiting(Utilities_1.synUtil.Strings.getValue("graph.fetchinggraph"), { autoHideAfter: 0 });
        })
            .off("fetchGraphComplete").on("fetchGraphComplete", function () {
            Utilities_1.synUtil.Notifications.remove(that.m_notificationGUID);
            that.m_notificationGUID;
        })
            .off("renderBegin").on("renderBegin", function () {
            Utilities_1.synUtil.Notifications.remove(that.m_notificationGUID);
            that.m_notificationGUID = Utilities_1.synUtil.Notifications.waiting(Utilities_1.synUtil.Strings.getValue("graph.renderinggraph"), { autoHideAfter: 0 });
        })
            .off("renderComplete").on("renderComplete", function (categories, relations) {
            Utilities_1.synUtil.Notifications.remove(that.m_notificationGUID);
            that.m_notificationGUID;
        })
            .off("noStartNode").on("noStartNode", () => {
            Utilities_1.synUtil.Notifications.remove(that.m_notificationGUID);
            that.m_notificationGUID = Utilities_1.synUtil.Notifications.error(Utilities_1.synUtil.Strings.getValue("graph.pleaseselectnode"));
        })
            .synGraph({});
    }
    wireCategoryChooserEvents() {
        let that = this;
        that.m_$categoryChooser
            .off("categoriesSelectedManually").on("categoriesSelectedManually", (evt, categories) => {
            let cats = [];
            if (!that.m_$categoryChooser.synCategoryChooser("areAllCategoriesSelected"))
                cats = $.map(categories, (cat) => { return cat.id.toString(); });
            else if (!that.m_$categoryChooser.synCategoryChooser("areNoCategoriesSelected"))
                cats = ["1"];
            that.setGraphOptions({ allowedCategories: cats }, true);
            that.m_$favorites.synFavorites("updateFavorite", that.getDataForNewFavorites());
        });
        that.m_$allButton.off("click").on("click", () => {
            that.m_$categoryChooser.synCategoryChooser("selectAllCategories");
            that.setGraphOptions({ allowedCategories: [] }, true);
            that.m_$favorites.synFavorites("updateFavorite", that.getDataForNewFavorites());
        });
        that.m_$noneButton.off("click").on("click", () => {
            that.m_$categoryChooser.synCategoryChooser("setSelectedCategories", []);
            that.setGraphOptions({ allowedCategories: ["1"] }, true);
            that.m_$favorites.synFavorites("updateFavorite", that.getDataForNewFavorites());
        });
    }
    wireLayoutDropDownEvents() {
        let that = this;
        let layoutDropDown = that.m_$layoutDropDown.data("kendoDropDownList");
        layoutDropDown.bind("change", function (e) {
            let layout = parseInt(layoutDropDown.value(), 10);
            if (layout === 1 /* TdOrganigramm */) {
                that.setParentDepth(1, false);
                that.setChildDepth(1, false);
            }
            that.enableParentSlider(layout !== 1 /* TdOrganigramm */);
            that.enableChildSlider(layout !== 1 /* TdOrganigramm */);
            that.setGraphOptions({ layoutType: layout }, true);
            that.m_$favorites.synFavorites("updateFavorite", that.getDataForNewFavorites());
        });
    }
    wireCheckBoxEvents() {
        let that = this;
        that.m_$showLabelsCheckBox
            .change(function () {
            that.setGraphOptions({ showDetails: $(this).is(":checked") }, true);
            that.m_$favorites.synFavorites("updateFavorite", that.getDataForNewFavorites());
        });
        that.m_$showIconsCheckBox
            .change(function () {
            that.setGraphOptions({ showIcons: $(this).is(":checked") }, true);
            that.m_$favorites.synFavorites("updateFavorite", that.getDataForNewFavorites());
        });
        that.m_$multiLineTitlesCheckBox
            .change(function () {
            that.setGraphOptions({ multiLineTitle: $(this).is(":checked") }, true);
            that.m_$favorites.synFavorites("updateFavorite", that.getDataForNewFavorites());
        });
    }
    wireSliderEvents() {
        let that = this;
        const parentSlider = that.m_$parentLevelSlider.data("kendoSlider");
        const childSlider = that.m_$childLevelSlider.data("kendoSlider");
        parentSlider.bind("change", function (e) {
            that.setGraphOptions({ parentDepth: parentSlider.value() }, true);
            that.m_$favorites.synFavorites("updateFavorite", that.getDataForNewFavorites());
        });
        childSlider.bind("change", function (e) {
            that.setGraphOptions({ childDepth: childSlider.value() }, true);
            that.m_$favorites.synFavorites("updateFavorite", that.getDataForNewFavorites());
        });
    }
    wireExternalChangeEvent() {
        if (!this.m_externalChangeEventRegistered) {
            this.m_externalChangeEventRegistered = true;
            $.address.externalChange((evt) => {
                if (evt.value === "/graph" || evt.value.indexOf("/graph?") === 0) {
                    this.getParametersFromUrl();
                    if (this.m_preset)
                        this.m_$favorites.synFavorites("selectFavorite", this.m_preset);
                    else
                        this.m_$favorites.synFavorites("trySelectDefaultFavorite");
                    this.setFavoriteOptionsAsync().then(() => {
                        this.m_$graphContainer.synGraph("navigateTo", this.m_id, true);
                    });
                }
            });
        }
    }
    initFavoritesAsync(initiallySelectedId) {
        let that = this;
        return new Promise((resolve, reject) => {
            that.m_$favorites = $("#configPane").find(".graphFavorites");
            that.m_$favorites
                .off("dataBound").on("dataBound", function () {
                resolve();
            })
                .synFavorites({
                readOnly: !that.m_editableFavorites,
                viewName: that.m_viewName,
                compact: false,
                showFavoriteSelectedNotification: false,
                initiallySelectedId
            });
        });
    }
}
exports.graph = graph;
